import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AllocateConsumerDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/init-step/allocate-consumer-date-info';
import { AllocateConsumerInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/init-step/allocate-consumers-init-step';
import { AllocateConsumerRequestV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/summary-step/allocate-consumer-request';
import { ConsumerDeskV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/users-step/consumer-desk';
import * as fromAllocateConsumerFromBillingitemWizard from './reducer';
import { State } from './state';

export const selectAllocateConsumerFromBillingitemWizardState = createFeatureSelector<State>(
  fromAllocateConsumerFromBillingitemWizard.allocateConsumerFromBillingitemWizardFeatureKey,
);

export const selectInitStep = createSelector(
  selectAllocateConsumerFromBillingitemWizardState,
  (state: State): AllocateConsumerInitStepV26 => state.initStep,
);

export const selectDatesStep = createSelector(
  selectAllocateConsumerFromBillingitemWizardState,
  (state: State): AllocateConsumerDueDatesV26 => state.datesStep,
);

export const selectUsersStep = createSelector(
  selectAllocateConsumerFromBillingitemWizardState,
  (state: State): ConsumerDeskV26[] => state.consumerDesksStep,
);

export const selectReuseAllocationStep = createSelector(
  selectAllocateConsumerFromBillingitemWizardState,
  (state: State): ConsumerDeskV26[] => state.reuseAllocationStep,
);

export const selectMiscellaneousStep = createSelector(
  selectAllocateConsumerFromBillingitemWizardState,
  (state: State): AllocateConsumerRequestV26 => state.miscellaneousStep,
);
